import { IItem } from "./IItem";
import { AbstractOptionSelectableTextItem } from "./AbstractOptionSelectableTextItem";
import { TypeKeys } from "./TypeKeys";
import { IEmptyValidatable } from "./IEmptyValidatable";
import { INameGroupEmptyValidatable } from "./INameGroupEmptyValidatable";
import { ObjectId } from "../ObjectId";
import { INaturalTextSpecifiable } from "./INaturalTextSpecifiable";

export class ComboBoxItem extends AbstractOptionSelectableTextItem implements
  IEmptyValidatable,
  INameGroupEmptyValidatable,
  INaturalTextSpecifiable {
  constructor(value: any, selectedSource: string | number) {
    super(TypeKeys.ComboBoxItem, value, selectedSource);
  }
 
  public isNaturalViewEnable: boolean;
  public naturalText: string;

  protected createCloneInstance(): ComboBoxItem {
    return new ComboBoxItem(this.originalValue, this.originalValueSource);
  }

  protected applyMembers(clone: ComboBoxItem): void {
    super.applyMembers(clone);
    clone.isNaturalViewEnable = this.cloneValue(this.isNaturalViewEnable);
    clone.naturalText = this.cloneValue(this.naturalText);
  }

  initialize(
    itemAccessor: (finder?: ObjectId | string | ((i: IItem) => boolean)) => IItem,
    itemsAccessor: (finder?: ObjectId | string | ((i: IItem) => boolean)) => IItem[]
  ): IItem {
    return this.getUpdatedClone<ComboBoxItem>(
      s => super.initialize(itemAccessor, itemsAccessor) as ComboBoxItem,
      // 本来であれば初期化時のフォーマット内転記はAbstractValuedItemで全体に適応しても良かったが、v1と動きを合わせるため個別(ComboBoxItemのみ)に判定している.
      s => s.shouldPasteOnUpdating ? s.clone() as ComboBoxItem : null,
    );
  }

  get currentNaturalText(): string {
    return this.isNaturalViewEnable && this.naturalText
      ? this.naturalText
      : this.text();
  }
}
